module.exports = __webpack_public_path__ + "img/st.cba19f5a.svg";